import { Papel } from "service/restricao/Papeis"

import { RestricoesCamposFormulario } from "../../service/restricao/RestricoesCamposFormulario"
import { OperacaoFormularioBusca } from "../../service/restricao/OperacaoFormulario/OperacaoFormulario"
import { RestricoesFormulario } from "../../service/restricao/RestricoesFormulario"
import { RestricaoBuscaFormulario } from "../../service/restricao/TipoRestricaoFormulario/RestricaoBuscaFormulario"


/**********************
  Campos do formulário em que se aplica as restrições
 **********************/
interface CamposRestricoes extends RestricoesCamposFormulario {
  inputSemRestricao: RestricaoBuscaFormulario;
  inputHidden: RestricaoBuscaFormulario;
  inputDisabled: RestricaoBuscaFormulario;
  inputReadOnly: RestricaoBuscaFormulario;
  inputReadOnlyVazio: RestricaoBuscaFormulario;
  inputClearable: RestricaoBuscaFormulario;

  selectSemRestricao: RestricaoBuscaFormulario;
  selectHidden: RestricaoBuscaFormulario;
  selectDisabled: RestricaoBuscaFormulario;
  selectReadOnly: RestricaoBuscaFormulario;
  selectReadOnlyVazio: RestricaoBuscaFormulario;
  selectClearable: RestricaoBuscaFormulario;
  
  selectMultiSemRestricao: RestricaoBuscaFormulario;
  selectMultiHidden: RestricaoBuscaFormulario;
  selectMultiDisabled: RestricaoBuscaFormulario;
  selectMultiReadOnly: RestricaoBuscaFormulario;
  selectMultiReadOnlyVazio: RestricaoBuscaFormulario;
  selectMultiClearable: RestricaoBuscaFormulario;

  cascaderSemRestricao: RestricaoBuscaFormulario;
  cascaderHidden: RestricaoBuscaFormulario;
  cascaderDisabled: RestricaoBuscaFormulario;
  cascaderReadOnly: RestricaoBuscaFormulario;
  cascaderReadOnlyVazio: RestricaoBuscaFormulario;
  cascaderClearable: RestricaoBuscaFormulario;

  editorSemRestricao: RestricaoBuscaFormulario;
  editorHidden: RestricaoBuscaFormulario;
  editorDisabled: RestricaoBuscaFormulario;
  editorReadOnly: RestricaoBuscaFormulario;
  editorReadOnlyVazio: RestricaoBuscaFormulario;
  editorClearable: RestricaoBuscaFormulario;
}


/**********************
  Perfis
 **********************/
const UsuarioComum: Readonly<CamposRestricoes> = {
  inputSemRestricao: { [OperacaoFormularioBusca.Buscar]: {} },
  inputHidden: { [OperacaoFormularioBusca.Buscar]: { hidden: true } },
  inputDisabled: { [OperacaoFormularioBusca.Buscar]: { disabled: true } },
  inputReadOnly: { [OperacaoFormularioBusca.Buscar]: { readOnly: true } },
  inputReadOnlyVazio: { [OperacaoFormularioBusca.Buscar]: { readOnly: true } },
  inputClearable: { [OperacaoFormularioBusca.Buscar]: { clearable: true } },

  selectSemRestricao: { [OperacaoFormularioBusca.Buscar]: {} },
  selectHidden: { [OperacaoFormularioBusca.Buscar]: { hidden: true } },
  selectDisabled: { [OperacaoFormularioBusca.Buscar]: { disabled: true } },
  selectReadOnly: { [OperacaoFormularioBusca.Buscar]: { readOnly: true } },
  selectReadOnlyVazio: { [OperacaoFormularioBusca.Buscar]: { readOnly: true } },
  selectClearable: { [OperacaoFormularioBusca.Buscar]: { clearable: true } },
  
  selectMultiSemRestricao: { [OperacaoFormularioBusca.Buscar]: {} },
  selectMultiHidden: { [OperacaoFormularioBusca.Buscar]: { hidden: true } },
  selectMultiDisabled: { [OperacaoFormularioBusca.Buscar]: { disabled: true } },
  selectMultiReadOnly: { [OperacaoFormularioBusca.Buscar]: { readOnly: true } },
  selectMultiReadOnlyVazio: { [OperacaoFormularioBusca.Buscar]: { readOnly: true } },
  selectMultiClearable: { [OperacaoFormularioBusca.Buscar]: { clearable: true } },

  cascaderSemRestricao: { [OperacaoFormularioBusca.Buscar]: {} },
  cascaderHidden: { [OperacaoFormularioBusca.Buscar]: { hidden: true } },
  cascaderDisabled: { [OperacaoFormularioBusca.Buscar]: { disabled: true } },
  cascaderReadOnly: { [OperacaoFormularioBusca.Buscar]: { readOnly: true } },
  cascaderReadOnlyVazio: { [OperacaoFormularioBusca.Buscar]: { readOnly: true } },
  cascaderClearable: { [OperacaoFormularioBusca.Buscar]: { clearable: true } },

  servidorSemRestricao: { [OperacaoFormularioBusca.Buscar]: {} },
  servidorHidden: { [OperacaoFormularioBusca.Buscar]: { hidden: true } },
  servidorDisabled: { [OperacaoFormularioBusca.Buscar]: { disabled: true } },
  servidorReadOnly: { [OperacaoFormularioBusca.Buscar]: { readOnly: true } },
  servidorReadOnlyVazio: { [OperacaoFormularioBusca.Buscar]: { readOnly: true } },
  servidorClearable: { [OperacaoFormularioBusca.Buscar]: { clearable: true } },

  editorSemRestricao: { [OperacaoFormularioBusca.Buscar]: {} },
  editorHidden: { [OperacaoFormularioBusca.Buscar]: { hidden: true } },
  editorDisabled: { [OperacaoFormularioBusca.Buscar]: { disabled: true } },
  editorReadOnly: { [OperacaoFormularioBusca.Buscar]: { readOnly: true } },
  editorReadOnlyVazio: { [OperacaoFormularioBusca.Buscar]: { readOnly: true } },
  editorClearable: { [OperacaoFormularioBusca.Buscar]: { clearable: true } },
}


/**********************
  Restrições por perfil
 **********************/
export const RestricoesTesteFormulario: RestricoesFormulario<CamposRestricoes> = {
  [Papel.UsuarioComum]: UsuarioComum,
  [Papel.Nivel1]: UsuarioComum,
  [Papel.Nivel2]: UsuarioComum,
  [Papel.Administrador]: UsuarioComum,
}